import { render, staticRenderFns } from "./CandleCard.vue?vue&type=template&id=3e9df878"
import script from "./CandleCard.vue?vue&type=script&lang=js"
export * from "./CandleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports